import React, { useCallback } from 'react';
import { Divider } from '@material-ui/core';
import {
    getTotalUsedQuantity,
    getTotalOtherQuantity,
    getTotalUsedTissueItemQuantity,
    getTotalOtherTissueItemQuantity,
    getTotalExtendedPrice,
    priceFormatObj,
    displayCheckbox,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import DiscountedPriceTemplate from 'src/pages/reportUsage/common/DiscountedPriceTemplate';
import {
    getPriceInNumberDataType,
    noPriceErrorMsg,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { StyledDiv, StyledPrices } from './itemPrices.styled';
import { sizes } from 'src/styles/Media.styled';
import {
    isIpad,
    isLandscape,
    isMobileDevice,
    setCurrencyFormat,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';

const ItemPrices = ({
    item,
    displayPrice,
    itemPricesWidth,
    isFromMobileView,
    isBundleItem,
    isFromReportScreen,
}) => {
    const { t } = useTranslation();
    const adjQtyLabel = useAdjQtyLabel();
    const getUsedAndOtherQuantity = useCallback(
        (item) => {
            const qtyObj = { usedQty: null, otherQty: null };
            if (item.salesOrg === 'S030' || displayCheckbox(item)) {
                qtyObj.usedQty = getTotalUsedTissueItemQuantity(item.lotSerial)
                    ? getTotalUsedTissueItemQuantity(item.lotSerial)
                    : null;
                if (getTotalOtherTissueItemQuantity(item.lotSerial)) {
                    qtyObj.otherQty = getTotalOtherTissueItemQuantity(
                        item.lotSerial
                    );
                }
            } else {
                qtyObj.usedQty =
                    getTotalUsedQuantity(item.lotSerial) === null
                        ? null
                        : getTotalUsedQuantity(item.lotSerial);
                if (getTotalOtherQuantity(item.lotSerial) !== null) {
                    qtyObj.otherQty = getTotalOtherQuantity(item.lotSerial);
                }
            }
            return qtyObj;
        },
        [item]
    );
    const isUsedOrOther = () => {
        if (isBundleItem) {
            return false;
        }
        const firstLotSerial = item.lotSerial?.[0];
        if (
            item.lotSerial &&
            (parseInt(firstLotSerial.used) > 0 ||
                parseInt(firstLotSerial.other) > 0 ||
                firstLotSerial.used === true ||
                firstLotSerial.other === true)
        ) {
            return true;
        }
        return false;
    };
    const isIpadPortrait = () => {
        if (isIpad()) {
            if (isLandscape()) {
                return false;
            }
            return true;
        }
        return false;
    };

    return (
        <StyledDiv
            width={itemPricesWidth}
            marginLeft={isFromReportScreen}
            paddingTop={
                (getUsedAndOtherQuantity(item).usedQty === null ||
                    getUsedAndOtherQuantity(item).otherQty === null) &&
                '0px'
            }
        >
            <StyledPrices
                display={'flex'}
                justifyContent={'space-between'}
                padding={
                    window.innerWidth <= sizes.mobileDevice
                        ? '0 12px 0 8px'
                        : ''
                }
                width={isFromMobileView && '100%'}
                margin={!isFromMobileView && isUsedOrOther() && '0 0 0 15px'}
            >
                {isBundleItem && isFromMobileView ? (
                    <StyledTextDiv
                        minWidth={isFromMobileView ? '5%' : '40px'}
                        width={isFromMobileView && '28%'}
                    >
                        {`${t(
                            'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                        )}: ${item.children ? item.children.length : 0}`}
                    </StyledTextDiv>
                ) : (
                    <StyledTextDiv
                        minWidth={isFromMobileView ? '5%' : '40px'}
                        width={
                            isFromMobileView
                                ? '31%'
                                : isFromMobileView && isBundleItem
                                ? '28%'
                                : '60px'
                        }
                    >
                        {isBundleItem
                            ? `${t(
                                  'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                              )}: ${item.children ? item.children.length : 0}`
                            : item.basePrice &&
                              getUsedAndOtherQuantity(item).usedQty !== null &&
                              `${t(
                                  'reportUsage.record.reportPayment.QuantityRPInputBoxes.used'
                              )}: ${getUsedAndOtherQuantity(item).usedQty}`}
                    </StyledTextDiv>
                )}
                {item.basePrice &&
                ((getUsedAndOtherQuantity(item).usedQty === null &&
                    getUsedAndOtherQuantity(item).otherQty === null) ||
                    (getUsedAndOtherQuantity(item).usedQty !== null &&
                        getUsedAndOtherQuantity(item).otherQty === null) ||
                    (getUsedAndOtherQuantity(item).usedQty !== null &&
                        getUsedAndOtherQuantity(item).otherQty !== null)) ? (
                    <>
                        {displayPrice && (
                            <DiscountedPriceTemplate
                                marginRightRp={'0px'}

                                priceWidth={isFromMobileView ? '28%' : '70px'}
                                marginLeftRp={
                                    isMobileDevice()
                                        ? ''
                                        : isIpadPortrait()
                                        ? '58px'
                                        : '0px'
                                }
                                isIpadMargin={true}
                                // priceWidth={isFromMobileView && '28%'}
                                originalPrice={item.basePrice}
                                adjustedPrice={
                                    !item.accountOwned &&
                                    item.adjustedUsedQtyPrice
                                }
                                modifiedPrice={
                                    item.accountOwned
                                        ? setCurrencyFormat(0)
                                        : item.adjustedUsedQtyPrice
                                        ? setCurrencyFormat(
                                              item.adjustedUsedQtyPrice
                                          )
                                        : item.basePrice
                                }
                                isFromReportScreen={isFromReportScreen}
                                isPriceNotAvailable={
                                    !item.accountOwned &&
                                    item.exclusionStatus === noPriceErrorMsg
                                }
                            />
                        )}
                        {displayPrice && (
                            <DiscountedPriceTemplate
                                priceWidth={isFromMobileView ? '28%' : '80px'}
                                originalPrice={item.usedQtyExtPrice}
                                adjustedPrice={
                                    !item.accountOwned &&
                                    item.adjustedUsedQtyPrice
                                }
                                modifiedPrice={
                                    item.accountOwned
                                        ? setCurrencyFormat(0)
                                        : getTotalExtendedPrice(
                                              item.adjustedUsedQtyPrice
                                                  ? item.adjustedUsedQtyPrice
                                                  : item.basePrice,
                                              item.lotSerial,
                                              'used'
                                          )
                                }
                                isFromReportScreen={isFromReportScreen}
                                marginRightRp={'0px'}
                                isPriceNotAvailable={
                                    !item.accountOwned &&
                                    item.exclusionStatus === noPriceErrorMsg
                                }
                            />
                        )}
                    </>
                ) : null}
            </StyledPrices>
            {item.basePrice &&
                getUsedAndOtherQuantity(item).usedQty !== null &&
                getUsedAndOtherQuantity(item).otherQty !== null && (
                    <div style={{ padding: '8px 0' }}>
                        <Divider orientation="horizontal" />
                    </div>
                )}
            {item.basePrice && getUsedAndOtherQuantity(item).otherQty !== null && (
                <StyledPrices
                    display={'flex'}
                    justifyContent={'space-between'}
                    padding={
                        window.innerWidth <= sizes.mobileDevice
                            ? '0 12px 0 8px'
                            : ''
                    }
                    width={isFromMobileView && '100%'}
                    margin={!isFromMobileView && '0 0 0 15px'}
                >
                    <StyledTextDiv
                        minWidth={isFromMobileView ? '5%' : '40px'}
                        width={isFromMobileView ? '31%' : '60px'}
                    >
                        {`${t(adjQtyLabel('reportUsage.itemList.other'))}: ${
                            getUsedAndOtherQuantity(item).otherQty
                        }`}
                    </StyledTextDiv>
                    {displayPrice && (
                        <DiscountedPriceTemplate
                            marginLeftRp={
                                isMobileDevice() ? '' : isIpad() ? '58px' : '0'
                            }
                            isIpadMargin={true}
                            priceWidth={isFromMobileView ? '28%' : '70px'}
                            originalPrice={item.basePrice}
                            adjustedPrice={
                                !item.accountOwned && item.adjustedOtherQtyPrice
                            }
                            modifiedPrice={
                                item.accountOwned
                                    ? setCurrencyFormat(0)
                                    : item.adjustedOtherQtyPrice
                                    ? setCurrencyFormat(
                                          item.adjustedOtherQtyPrice
                                      )
                                    : item.basePrice
                            }
                            isFromReportScreen={isFromReportScreen}
                            isPriceNotAvailable={
                                !item.accountOwned &&
                                item.exclusionStatus === noPriceErrorMsg
                            }
                        />
                    )}
                    {displayPrice && (
                        <DiscountedPriceTemplate
                            priceWidth={isFromMobileView ? '28%' : '80px'}
                            originalPrice={item.otherQtyExtPrice}
                            adjustedPrice={
                                !item.accountOwned && item.adjustedOtherQtyPrice
                            }
                            modifiedPrice={
                                item.accountOwned
                                    ? setCurrencyFormat(0)
                                    : getTotalExtendedPrice(
                                          item.adjustedOtherQtyPrice
                                              ? item.adjustedOtherQtyPrice
                                              : item.basePrice,
                                          item.lotSerial,
                                          'other'
                                      )
                            }
                            isFromReportScreen={isFromReportScreen}
                            marginRightRp={'0px'}
                            isPriceNotAvailable={
                                !item.accountOwned &&
                                item.exclusionStatus === noPriceErrorMsg
                            }
                        />
                    )}
                </StyledPrices>
            )}
           
        </StyledDiv>
    );
};

export default ItemPrices;
